import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReimbursementformService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) { 
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  ESS_ReimbursementRequest_Load(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReimbursementRequest_Load/Get`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
  ESS_ReimbursementRequest_Insert(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReimbursementRequest_Insert/Update`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_LoadReimbursementHistory(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LoadReimbursement/History`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }


  ESS_ReimbursementRequestUpdate_At(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ReimbursementRequestUpdate_At/Approval`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

}
